// Trimmed from LC2 (src/app/store/store.js) — same configureStore setup, middleware
// list grows as each API slice gets ported alongside its pages.
import {configureStore} from '@reduxjs/toolkit';
import reducer from './reducers/reducer';

import {loyaltyCloudApi} from '../../features/loyaltyCloudApi/apiSlice';
import {coreApiSlice} from '../../features/coreApi/apiSlice';
import {actionsApiSlice} from '../../features/actionsApi/apiSlice';
import {messagingApiSlice} from '../../features/messagingApi/apiSlice';

const middleware = [loyaltyCloudApi.middleware, coreApiSlice.middleware, actionsApiSlice.middleware, messagingApiSlice.middleware];

export const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat(middleware),
    devTools: process.env.NODE_ENV === 'development',
    preloadedState: {}
});
